enum WORK_UNIT_PRIORITY {
  High = '9000',
  Normal = '10000',
  PP = '1000',
  Rerun = '999',
}
export default WORK_UNIT_PRIORITY;
